import React, { useEffect, useState } from 'react';
import { ConfirmDeleteMessage } from '../../extras/toastMessages';
import { ACTION_EDIT, ACTION_DELETE } from '../../extras/actionTypes';
import TableList from '../../layout/TableList';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { listRecusesAction, editRecusesAction, deleteRecusesAction } from '../../../actions/recusesActions';
import { MSG_DELETE, MSG_NOT_REVERT_OPERATION } from '../../../constants/messages';
import { Spinner } from 'react-bootstrap';
import AuthoritiesService from '../../../services/AuthoritiesService';
import { PARAMETROS_ELIMINAR, RECUSACIONES_ELIMINAR } from '../../../data/objects';
import QuickFilter from '../../layout/QuickFilter';
import Paginator from '../../layout/Paginator';
import RecuseSearch from './RecuseSearch';
//Función principal
const RecuseList = props => {
    //Constantes iniciales
    const initialPage = 0;
    const pageSize = 10;
    //Tomo los props
    const { handleOpen, handleClose } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const authorities = useSelector(state => state.auth.authorities);
    const recusesLoading = useSelector( state => state.recuses.loading );
    const recuses = useSelector( state => state.recuses.recuses );
    const isLast = useSelector(state => state.recuses.isLast);
    const isFirst = useSelector(state => state.recuses.isFirst);
    const total = useSelector(state => state.recuses.total);
    const totalPages = useSelector(state => state.recuses.totalPages);
    const actualPage = useSelector(state => state.recuses.actualPage);
    //Inicializo el state local
    const [ search, setSearch ] = useState('');
    //Parámetros iniciales
    const params = {
        paging: `${initialPage},${pageSize}`,
        sort: 'id:desc',
        search
    }
    //Manejo de la edición
    const handleEdit = item => {
        //Llamo al dispatch de edición
        dispatch( editRecusesAction(item, handleOpen) );
    }
    //Manjo la eliminación
    const handleDelete = item => {
        //Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteRecusesAction(item) )
            }
        )
    }
    //Inicializo las cabeceras
    const headers = [
        {
            name: 'Apellido',
            width: null,
            style: null,
            field: 'juez',
            subfield: 'apellido'
        },
        {
            name: 'Nombre',
            width: null,
            style: null,
            field: 'juez',
            subfield: 'nombre'
        },
        {
            name: 'Expediente',
            width: null,
            style: 'text-center',
            field: 'expediente',
            subfield: 'numero'
        },
        {
            name: 'Motivo',
            width: null,
            style: 'text-center',
            field: 'motivo',
            subfield: 'descripcion'
        },
        {
            name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                // {
                //     name: ACTION_EDIT,
                //     handle: handleEdit
                // },
                {
                    name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, RECUSACIONES_ELIMINAR)
                }
            ]
        }
    ];
    //Cargo los datos
    useEffect(() => {
        //Cargo los datos
        loadData(params);
    }, [search]);
    //Manejo la carga de datos
    const loadData = parameters => {
        //Llamo al dispatch
        dispatch( listRecusesAction(parameters) );
    }
    //Renderizo
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <RecuseSearch
                            setSearch={setSearch}
                        />

                        <hr/>
                        
                        {
                            recusesLoading ? (
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                </Spinner>
                            ) : null
                        }
                        {
                            recuses ? (
                                <React.Fragment>
                                    <TableList
                                        prefix="ofiju"
                                        headers={headers}
                                        items={recuses}
                                        state={{
                                            field: 'activo',
                                            disabledClass: 'table-danger',
                                            disabledValue: 0,
                                            hideActions: true
                                        }}
                                    />
                                    <Paginator
                                        actualPage={actualPage}
                                        totalPages={totalPages}
                                        isFirst={isFirst}
                                        isLast={isLast}
                                        pageSize={pageSize}
                                        params={params}
                                        loadData={loadData}
                                    />
                                </React.Fragment>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecuseList;